import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import RichTextEditor from 'react-rte'

function TextAreaHtml({ value, handleEditor, placeholder, disabled, checkIsRed, strToCheckIsRed }) {
  const [editorState, setEditorState] = useState({
    value: RichTextEditor.createValueFromString(value, 'html')
  })

  useEffect(() => {
    setEditorState({
      value: RichTextEditor.createValueFromString(value, 'html')
    })
  }, [])

  const handleEdit = str => {
    setEditorState({ value: str })
    handleEditor(str.toString('html'))
  }

  return (
    <div className={`form-group col-12 ${checkIsRed(strToCheckIsRed) && 'clube-border-danger'}`}>
      <h6 style={{ marginTop: 10 }}>{placeholder}</h6>
      <RichTextEditor
        value={editorState.value}
        onChange={handleEdit}
        disable={disabled}
        readOnly={disabled}
      />
    </div>
  )
}

TextAreaHtml.defaultProps = {
  disabled: false,
  strToCheckIsRed: '',
  value: '',
  checkIsRed: () => {}
}

TextAreaHtml.propTypes = {
  value: PropTypes.string,
  handleEditor: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checkIsRed: PropTypes.func,
  strToCheckIsRed: PropTypes.string
}

export default TextAreaHtml
